import { render, staticRenderFns } from "./dataBaseSearch.vue?vue&type=template&id=1b42861d&scoped=true&"
import script from "./dataBaseSearch.vue?vue&type=script&lang=js&"
export * from "./dataBaseSearch.vue?vue&type=script&lang=js&"
import style0 from "./dataBaseSearch.vue?vue&type=style&index=0&id=1b42861d&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b42861d",
  null
  
)

export default component.exports